import { RootState } from '@/store'
import { getConfiguration } from '@/store/selectors'

export const getScimToken = (state: RootState) => {
  return state.organizationUserProvisioningPage.webKeys ? state.organizationUserProvisioningPage.webKeys[0] : null
}

export const getUserManagementConnectors = (state: RootState) => {
  return state.organizationUserProvisioningPage.accountManagementConnectors || []
}

export const getApiHost = (state: RootState) => {
  return getConfiguration(state).apiHost
}
